import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const PrivateCoaching = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Private Coaching</h2>
                            <p>
                                The Private Coaching program at Net Nest Badminton Sports Club is specially designed for players who want personalized attention, faster improvement, and focused skill development. This one-on-one training approach allows players to work closely with experienced coaches and achieve their badminton goals more efficiently.
                            </p>
                            <h2>Personalized Training Approach</h2>
                            <p>
                                Age and skill level
                                <br></br>
                                Strengths and weaknesses
                                <br></br>
                                Fitness and flexibility
                                <br></br>
                                Short-term and long-term goals
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Individual Skill Development</h2>
                            <p>
                                Stroke techniques (smash, drop, clear, net play)
                                <br></br>
                                Footwork, balance, and court movement
                                <br></br>
                                Shot accuracy and consistency
                                <br></br>
                                Timing, coordination, and reaction speed
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Tactical & Match Strategy Training</h2>
                            <p>
                                Match planning and shot selection
                                <br></br>
                                Opponent analysis and game tactics
                                <br></br>
                                Singles and doubles positioning strategies
                                <br></br>
                                Decision-making under match pressure
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Fitness & Physical Conditioning Support</h2>
                            <p>
                                Speed, agility, and endurance
                                <br></br>
                                Strength and explosive power
                                <br></br>
                                Injury prevention and recovery techniques
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Strength & Confidence Building</h2>
                            <p>
                                Building self-confidence
                                <br></br>
                                Improving focus and concentration
                                <br></br>
                                Managing pressure during matches
                                <br></br>
                                Developing a positive competitive mindset
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexible Scheduling & Convenience</h2>
                            <p>
                                Students
                                <br></br>
                                Working professionals
                                <br></br>
                                Competitive players with busy schedules
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Faster Progress & Performance Tracking</h2>
                            <p>
                                Track performance improvements
                                <br></br>
                                Adjust training methods as needed
                                <br></br>
                                Set achievable milestones and targets
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Ideal for All Player Levels</h2>
                            <p>
                                Beginners seeking a strong foundation
                                <br></br>
                                Intermediate players aiming for improvement
                                <br></br>
                                Advanced athletes preparing for tournaments
                                <br></br>
                                Players returning after a break or injury
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PrivateCoaching;
